<template>
  <PortfolioFormLayout :loading="loading">
    <template #header>
      <h5 class="my-2">{{ isUpdateForm ? 'Update' : 'Create' }} Component Type</h5>
    </template>
    <template #body>
      <ComponentTypeFormPresentational
        v-model:cost-unit-calc-method="costUnitCalcMethod"
        v-model:description="description"
        v-model:name="name"
        :error-messages="errorMessages"
        :loading="loadingSubmit"
        :server-error="serverError"
        @submit="submit"
      />
    </template>
  </PortfolioFormLayout>
</template>
<script lang="ts" setup>
import {Detail} from '@/api/errorMessage';
import {ComponentTypeCreateUpdate} from '@/stores/userManagement/userManagement';

const props = defineProps<{
  isUpdateForm: boolean;
  loading: boolean;
  id?: number;
}>();

const router = useRouter();

// Stores
const componentTypesStore = useComponentTypesStore();
const getComponentTypes = computed(() => componentTypesStore.getComponentTypes);

const loadingSubmit = ref(false);

// Form data
const name = ref('');
const description = ref('');
const costUnitCalcMethod = ref('');
const errorMessages = ref(new Map());
const serverError = ref(false);

const submit = async (form: globalThis.Ref<HTMLFormElement | null>) => {
  try {
    loadingSubmit.value = true;
    const componentType: ComponentTypeCreateUpdate = {
      name: name.value,
      description: description.value,
      cost_unit_calculation_method: costUnitCalcMethod.value,
    };
    if (!props.isUpdateForm) {
      await componentTypesStore.createComponentType(componentType);
      router.go(-1);
    } else {
      const updateComponentType: ComponentTypeCreateUpdate = {
        ...componentType,
        id: Number(props.id),
      };
      await componentTypesStore.updateComponentType(updateComponentType);
      router.go(-1);
    }
  } catch (errorMessage: any) {
    serverError.value = true;
    errorMessages.value = new Map();
    form.value?.classList.remove('was-validated');
    if (typeof errorMessage === 'object') {
      errorMessage.forEach((d: Detail) => errorMessages.value.set(d.loc[1], d.msg));
    }
    form.value?.classList.remove('was-validated');
    console.log(errorMessage);
  } finally {
    loadingSubmit.value = false;
  }
};

const load = async () => {
  if (props.isUpdateForm === true) {
    // Try find the item in store state
    let item = getComponentTypes.value.find((pt) => pt.id === props.id);
    // If the item is missing, try to fetch it
    if (item === undefined && props.id !== undefined) {
      try {
        const data = await componentTypesStore.readComponentTypeById(props.id);
        item = data;
      } catch (error) {
        console.log(error);
      }
    }
    if (item !== undefined) {
      // Set the form data
      name.value = item.name;
      description.value = item.description;
      costUnitCalcMethod.value = item.cost_unit_calculation_method;
    }
  }
};

onMounted(() => load());
</script>
